module.exports = __webpack_public_path__ + "static/media/four_pote_pricing.43975e23.png";